(() => {
  const inputMode = mode => { document.documentElement.dataset.nzInput = mode; };
  inputMode('pointer');
  document.addEventListener('pointerdown', () => inputMode('pointer'), true);
  document.addEventListener('keydown', event => {
    if (['Tab','ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(event.key)) inputMode('keyboard');
  }, true);
  document.addEventListener('click', event => {
    const filter = event.target.closest('[data-c03-filter]');
    if (!filter) return;
    const root = filter.closest('[data-c03-products]');
    let count = 0;
    root.querySelectorAll('[data-c03-pet]').forEach(card => {
      card.hidden = filter.dataset.c03Filter !== 'all' && !['both',filter.dataset.c03Filter].includes(card.dataset.c03Pet);
      if (!card.hidden) count++;
    });
    root.querySelectorAll('[data-c03-filter]').forEach(button => {
      button.classList.toggle('active',button === filter);
      button.setAttribute('aria-pressed',String(button === filter));
    });
    const counter = root.querySelector('[data-c03-count]');
    counter.textContent = counter.textContent.replace(/\d+/,String(count));
    window.NuzzlinoMotion?.filter(root);
  });
})();
